var OmniExperimentType;
(function (OmniExperimentType) {
    OmniExperimentType[OmniExperimentType["FULL_SCAN"] = 0] = "FULL_SCAN";
    OmniExperimentType[OmniExperimentType["SNAPSHOT_PATTERNS"] = 1] = "SNAPSHOT_PATTERNS";
})(OmniExperimentType || (OmniExperimentType = {}));
export default OmniExperimentType;
